// extracted by mini-css-extract-plugin
export default {"fontStyrene":"aWClFS","externalFont":"bWClFS"};